import { type FieldConfiguration } from './types';

export function parseDependsOn(value: string): Partial<FieldConfiguration> | undefined {
  const trimmedValue = value.trim();

  if (trimmedValue.length < 3) {
    return undefined;
  }

  return { dependsOn: trimmedValue.slice(1, -1) };
}
